import { render } from "./listComponent.vue?vue&type=template&id=c01de2bc"
import script from "./listComponent.vue?vue&type=script&lang=js"
export * from "./listComponent.vue?vue&type=script&lang=js"

import "./listComponent.vue?vue&type=style&index=0&id=c01de2bc&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__